import styled from 'styled-components'
import { SanitizedHtmlDisplay } from '@/components/common/etc'
import { LayoutHeader } from '@/components/domains/layouts'
import { useCustomRouter } from '@/containers/hooks'
import { useExchangeRefundGuideQuery } from '@/containers/hooks/exchange-refund-guide/useExchangeRefundGuideQuery'

const PageProductExchangeRefundGuide = () => {
  const { query } = useCustomRouter()
  const { productId } = query as { productId: string }
  const { data } = useExchangeRefundGuideQuery({ productId })

  if (!productId) {
    return null
  }

  return (
    <>
      <LayoutHeader />
      <StyledContainer>
        <SanitizedHtmlDisplay dirtyHtmlString={data} />
      </StyledContainer>
    </>
  )
}

const StyledContainer = styled.div`
  padding: 20px;
`

export default PageProductExchangeRefundGuide
